import { useCallback } from 'react';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../../api';
import { backerKeys } from '../../../query-key-factory';
import { ConsumerBackerIntentResponse } from './intent.types';

const useGetBackerConsumerBackerIntent = () => {
  const BackerApi = useBackerApi();

  const getBackerIntent = useCallback(async () => {
    const { data } = await BackerApi.get<ConsumerBackerIntentResponse>('/consumer/backer/intent');
    return data;
  }, [BackerApi]);

  return getBackerIntent;
};

const useShowConsumerBackerIntent = <T = ConsumerBackerIntentResponse>({
  select,
}: { select?: (data: ConsumerBackerIntentResponse) => T } = {}) => {
  const getConsumerBackerIntent = useGetBackerConsumerBackerIntent();

  return useQuery({
    queryKey: backerKeys.consumer.backer.intent.detail,
    queryFn: getConsumerBackerIntent,
    select,
  });
};

const usePrefetchConsumerBackerIntent = () => {
  const getConsumerBackerIntent = useGetBackerConsumerBackerIntent();
  const queryClient = useQueryClient();

  //Same reference across renders
  return useCallback(async () => {
    await queryClient.prefetchQuery({
      queryKey: backerKeys.consumer.backer.intent.detail,
      queryFn: getConsumerBackerIntent,
    });
  }, [queryClient, getConsumerBackerIntent]);
};

export { usePrefetchConsumerBackerIntent, useShowConsumerBackerIntent };
